export default __webpack_public_path__ + "static/media/image4.7021f7ee.png";